import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 5000,
});

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// ── Connexion PLC ──────────────────────────────────────────────
export const getPlcSettings = (token) =>
  api.get('/api/config/plc', authHeader(token)).then(r => r.data);

export const updatePlcSettings = (token, settings) =>
  api.put('/api/config/plc', settings, authHeader(token)).then(r => r.data);

// ── Registres ────────────────────────────────────────────────
export const getAppRegisters = (token, app) =>
  api.get(`/api/config/registers/${app}`, authHeader(token)).then(r => r.data);

export const updateAppRegisters = (token, app, payload) =>
  api.put(`/api/config/registers/${app}`, payload, authHeader(token)).then(r => r.data);

// ── Informations réseau ──────────────────────────────────────
export const getNetworkInfo = (token) =>
  api.get('/api/config/network-info', authHeader(token)).then(r => r.data);

// ── Extrait un message d'erreur lisible depuis une erreur axios ─
export const getErrorMessage = (error, fallback = "Une erreur est survenue.") =>
  error?.response?.data?.detail || fallback;